let initialFields = {
  breastFeeding: 'Exclusive',
  // caloriesPerDay: "",
};

export default initialFields;
